export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/a2cdf02300b2663230f496dbfe02b4a0.svg";